<template>
    <span class="notification-item">
        <div v-if="type === 'interventions'" class="d-flex cursor-pointer">
            <img src="/images/icons_interventions/plomberie.png" alt="" class="mr-4 category-icon"/>
            <div>
                <p class="mb-0"><strong> Le locataire <span class="primary_">{{tenant}}</span></strong></p>
                <p>a déclaré un incident dans la catégorie <span class="primary_">{{category}}</span> pour la résidence <span class="primary_">{{location}}</span> à date du <span class="primary_">{{date}}</span></p>
            </div>
        </div>
        <div v-if="type === 'baux'" class="d-flex cursor-pointer">
            <div>
                <p class="mb-0"><strong> Le locataire <span class="primary_">{{tenant}}</span></strong></p>
                <p>a évoqué un problème de paiement pour le logement <span class="primary_">{{location}}</span> à date du <span class="primary_">{{date}}</span></p>
            </div>
        </div>
        <div v-if="type === 'annonces'" class="d-flex cursor-pointer">
            <div>
                <p class="mb-0"><strong> Le locataire <span class="primary_">{{tenant}}</span></strong></p>
                <p>a a posté une annonce de la catégorie <span class="primary_">{{category}}</span> pour la résidence <span class="primary_">{{location}}</span> à date du <span class="primary_">{{date}}</span></p>
            </div>
        </div>
    </span>
</template>

<style lang="scss">
    .category-icon{
        width: 20px;
        height: 20px;
    }
    p{
        margin-bottom: 0 !important;
    }
</style>

<script>
export default {
  name: 'PanelRightNotification',
  props: ['type', 'tenant', 'category', 'location', 'date'],
  data: () => ({})
}
</script>